import { matchPath } from 'react-router-dom';

import { PageType } from '../../types/graphql';
import { PathInfo } from '../context/PathInfo';
import { CustomError } from '../components/ErrorBoundary/errors';

const PREFIX_TO_TYPE: Record<string, PageType> = {
  crowdfunding: PageType.Crowdfunding,
  page: PageType.OnePage,
  fundraising: PageType.OnePage,
  campaign: PageType.Campaign,
  charity: PageType.Charity,
};

export const parsePath = (currentPath: string): PathInfo => {
  // Try both patterns and use the first match
  const match =
    matchPath({ path: '/:prefix/:shortName/admin/*' }, currentPath) ||
    matchPath({ path: '/:prefix/admin/*' }, currentPath);

  const prefix = match?.params?.prefix;
  const shortName = (match?.params as any)?.shortName;
  const pageType = prefix ? PREFIX_TO_TYPE[prefix] : null;

  if (!match || !pageType) {
    throw new CustomError({ message: 'Page not found', code: 404 });
  }

  return {
    pageType,
    pageSlug: getPageSlug(pageType, prefix!, shortName),
  };
};

const getPageSlug = (
  pageType: PageType,
  prefix: string,
  shortName?: string
) => {
  switch (true) {
    case pageType === PageType.Campaign:
      return '';
    case (pageType === PageType.OnePage || pageType === PageType.Charity) &&
      Boolean(shortName):
      return `${prefix}/${shortName}`;
    case pageType === PageType.Crowdfunding && Boolean(shortName):
      return shortName!;
    default:
      throw new CustomError({
        message: `Unknown page type: ${pageType}`,
        code: 500,
      });
  }
};

export default parsePath;
